var _defs, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgVelma(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 73,
    height: 73,
    viewBox: "0 0 73 73",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "Ellipse_384",
    x: 0,
    y: 0,
    width: 73,
    height: 73,
    filterUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("feOffset", {
    dy: 3,
    input: "SourceAlpha"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 3,
    result: "blur"
  }), /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0.161
  }), /*#__PURE__*/React.createElement("feComposite", {
    operator: "in",
    in2: "blur"
  }), /*#__PURE__*/React.createElement("feComposite", {
    in: "SourceGraphic"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_29239",
    "data-name": "Group 29239",
    transform: "translate(64 10837)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1, 0, 0, 1, -64, -10837)",
    filter: "url(#Ellipse_384)"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_384-2",
    "data-name": "Ellipse 384",
    cx: 27.5,
    cy: 27.5,
    r: 27.5,
    transform: "translate(9 6)",
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Path_50303",
    "data-name": "Path 50303",
    d: "M12.8,29.447s-2.17.4-2,3.659,6.375,9.246,12.315,9.246S28.488,37.5,28.488,37.5s4.071-3.659.3-5.189S12.8,29.447,12.8,29.447Z",
    transform: "translate(-47.564 -10829.137)",
    fill: "#f57c00"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_50304",
    "data-name": "Path 50304",
    d: "M15.009,21.3C11.1,24.769,4.2,24.6,4.2,13.822S14.209,0,18.147,0,33.065,2.341,29.994,12.086c3.371,3,2.067,7.813-1.7,8.243C25.706,20.626,17.646,21.131,15.009,21.3Z",
    transform: "translate(-45.566 -10820.22)",
    fill: "#5a2227"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_50305",
    "data-name": "Path 50305",
    d: "M13.053,22.787c.3.89,1.135,2.57,4.605,2.17a4.727,4.727,0,0,1-2.351,2.612,12.842,12.842,0,0,0,8.863,3.651c3.485-.052,7.669-3.486,7.669-7.669a3.936,3.936,0,0,0-.753-1.857,5.327,5.327,0,0,1-.8-4.066l.386-2.017a5.247,5.247,0,0,1-3.2.1,5.246,5.246,0,0,1-4.939.158c-2.441.9-4.644,1.152-6.409.206-1.569,2.069-2.269,5.607.5,6.842A5.03,5.03,0,0,1,13.053,22.787Z",
    transform: "translate(-48.249 -10824.946)",
    fill: "#ffcc80"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_8464",
    "data-name": "Rectangle 8464",
    width: 12.549,
    height: 1.394,
    transform: "translate(-33.838 -10806.973)",
    fill: "#039be5"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_50306",
    "data-name": "Path 50306",
    d: "M18.966,18.815a8.228,8.228,0,0,0,.7,4.88,19.5,19.5,0,0,0,5.577,0,13.276,13.276,0,0,0,0-4.88A11.744,11.744,0,0,0,18.966,18.815Z",
    transform: "translate(-50.016 -10825.787)",
    fill: "#039be5"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_50307",
    "data-name": "Path 50307",
    d: "M31,18.815l.7,4.88a14.308,14.308,0,0,0,5.147-.6,13.546,13.546,0,0,0,.43-4.279A11.749,11.749,0,0,0,31,18.815Z",
    transform: "translate(-53.684 -10825.787)",
    fill: "#039be5"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_50308",
    "data-name": "Path 50308",
    d: "M30.144,23.8a3.336,3.336,0,0,0,1.4.467c.634,0,1.2,1.1-.434,2.47.4-1,.367-1.635-.2-1.836S30.144,23.8,30.144,23.8Z",
    transform: "translate(-53.425 -10827.426)",
    fill: "#efad60"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_483",
    "data-name": "Ellipse 483",
    cx: 0.697,
    cy: 0.697,
    r: 0.697,
    transform: "translate(-28.261 -10805.578)"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_484",
    "data-name": "Ellipse 484",
    cx: 0.697,
    cy: 0.697,
    r: 0.697,
    transform: "translate(-20.593 -10805.578)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_50309",
    "data-name": "Path 50309",
    d: "M22.628,29.471l.555-.585a1.489,1.489,0,0,0,1.781.514,7.252,7.252,0,0,1,4.177-.033c.679.221,1.007-.369,1.328-.777l.57.4c-.334.979-1.268,2.086-2.475,1.649a5.45,5.45,0,0,0-3.2.1A2.06,2.06,0,0,1,22.628,29.471Z",
    transform: "translate(-51.149 -10828.877)",
    fill: "#efad60"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgVelma);
export default __webpack_public_path__ + "static/media/velma.139be788d47ce6a7d9ce4cb4efe8b469.svg";
export { ForwardRef as ReactComponent };